import page from '../helpers/page';

page(() => {
    ymaps.ready(init);

    function init() {
        var myMap = new ymaps.Map("deliveryMap", {
            center: [59.938951, 30.315635],
            zoom: 10
        }, {
            suppressMapOpenBlock: true
        });
        var myPolyline = new ymaps.Polyline([
            [60.060836, 30.138027],
            [60.068386, 30.166872],
            [60.082791, 30.205316],
            [60.087596, 30.230032],
            [60.097885, 30.254773],
            [60.096517, 30.337168],
            [60.089653, 30.374242],
            [60.075932, 30.382474],
            [60.062894, 30.383848],
            [60.049156, 30.419567],
            [60.036802, 30.438790],
            [60.017548, 30.463509],
            [59.999674, 30.474493],
            [59.983170, 30.495100],
            [59.975590, 30.533545],
            [59.963886, 30.554145],
            [59.927398, 30.530786],
            [59.890907, 30.523934],
            [59.864564, 30.528094],
            [59.847308, 30.464862],
            [59.825195, 30.436055],
            [59.804443, 30.324805],
            [59.838332, 30.278102],
            [59.811357, 30.199835],
            [59.819668, 30.186098],
            [59.854222, 30.177850],
            [59.890812, 30.236899],
            [59.902538, 30.212193],
            [59.925958, 30.208050],
            [59.948731, 30.208059],
            [59.963890, 30.210824],
            [59.977645, 30.228667],
            [60.005173, 30.238276],
            [60.032649, 30.197121],
            [60.035421, 30.161387],
            [60.060836, 30.138027],
        ], {
            balloonContent: "Пределы доставки SPOT"
        }, {
            balloonCloseButton: false,
            strokeColor: "#188606",
            strokeWidth: 4,
            strokeOpacity: 1,
        });

        myMap.geoObjects.add(myPolyline);
    }
})